export default __webpack_public_path__ + "static/media/card-lumpsum-icon.8e5c033d.svg";